import React from 'react';
import { COMPANY } from '../../constants/company';

export const WebsiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Smile Consent",
    "url": "https://smileconsent.co.uk",
    "description": "Digital dental consent software for UK practices. Paperless workflows, GDC compliance, e-signatures & practice management.",
    "sameAs": [
      "https://smileconsent.co.uk/digital-consent-dentists",
      "https://smileconsent.co.uk/dental-consent-forms", 
      "https://smileconsent.co.uk/dental-consent-plans",
      "https://smileconsent.co.uk/dental-compliance-software",
      "https://smileconsent.co.uk/dental-practice-management",
      "https://smileconsent.co.uk/dental-templates",
      "https://smileconsent.co.uk/dentaltriage"
    ]
  };

  return schema;
};

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": COMPANY.tradingName,
    "legalName": COMPANY.legalName,
    "identifier": COMPANY.number,
    "url": "https://smileconsent.co.uk",
    "logo": "https://smileconsent.co.uk/logo.png",
    "description": "Leading provider of digital dental consent software for UK dental practices",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "email": "info@smileconsent.co.uk"
    },
    "sameAs": [
      "https://smileconsent.co.uk/digital-consent-dentists",
      "https://smileconsent.co.uk/dental-consent-forms",
      "https://smileconsent.co.uk/dental-consent-plans", 
      "https://smileconsent.co.uk/dental-compliance-software",
      "https://smileconsent.co.uk/dental-practice-management",
      "https://smileconsent.co.uk/dental-templates",
      "https://smileconsent.co.uk/dentaltriage"
    ]
  };

  return schema;
};

export const WebPageSchema = ({ name, url, description }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": name,
    "url": url,
    "description": description,
    "isPartOf": {
      "@type": "WebSite",
      "name": "Smile Consent",
      "url": "https://smileconsent.co.uk"
    },
    "about": {
      "@type": "Thing",
      "name": "Digital Dental Consent Software"
    }
  };

  return schema;
};

export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.url ? `https://smileconsent.co.uk${item.url}` : undefined
    }))
  };

  return schema;
};
